import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Input() success: string = 'Thank you for your interest in Born Primitive\'s TAA and Berry programs. We will be in touch shortly.';

  colorsOfInterest: string[] = [
    "Blackout",
    "Police Blue",
    "Coyote",
    "Khaki",
    "Gunmetal",
    "OD Green",
    "Ranger Green",
    "Black - Limited Time",
    "Desert Tan - Limited Time",
    "Wolf Grey - Limited Time",
    "Coyote Brown - Limited Time"
  ];
  countryData: any = {};
  countries: { code: string; name: string }[] = [];
  provinces: { key: string; label: string }[] = [];
  countryDisplayOrder = ['US', 'GB', 'CA', 'FR', 'AU'];
  phoneCountries: any[] = [
    { name: 'United States', dialCode: '+1', flag: '🇺🇸' },
    { name: 'Canada', dialCode: '+1', flag: '🇨🇦' },
    { name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
    { name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
    { name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
    // EU Countries
    { name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
    { name: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
    { name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
    { name: 'Croatia', dialCode: '+385', flag: '🇭🇷' },
    { name: 'Cyprus', dialCode: '+357', flag: '🇨🇾' },
    { name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿' },
    { name: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
    { name: 'Estonia', dialCode: '+372', flag: '🇪🇪' },
    { name: 'Finland', dialCode: '+358', flag: '🇫🇮' },
    { name: 'France', dialCode: '+33', flag: '🇫🇷' },
    { name: 'Germany', dialCode: '+49', flag: '🇩🇪' },
    { name: 'Greece', dialCode: '+30', flag: '🇬🇷' },
    { name: 'Hungary', dialCode: '+36', flag: '🇭🇺' },
    { name: 'Ireland', dialCode: '+353', flag: '🇮🇪' },
    { name: 'Italy', dialCode: '+39', flag: '🇮🇹' },
    { name: 'Latvia', dialCode: '+371', flag: '🇱🇻' },
    { name: 'Lithuania', dialCode: '+370', flag: '🇱🇹' },
    { name: 'Luxembourg', dialCode: '+352', flag: '🇱🇺' },
    { name: 'Malta', dialCode: '+356', flag: '🇲🇹' },
    { name: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
    { name: 'Poland', dialCode: '+48', flag: '🇵🇱' },
    { name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
    { name: 'Romania', dialCode: '+40', flag: '🇷🇴' },
    { name: 'Slovakia', dialCode: '+421', flag: '🇸🇰' },
    { name: 'Slovenia', dialCode: '+386', flag: '🇸🇮' },
    { name: 'Spain', dialCode: '+34', flag: '🇪🇸' },
    { name: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  ];
  selectedCountry: any = this.phoneCountries[0];

  selectCountry(country: any) {
    this.selectedCountry = country;
  }

  ngOnInit() {
    this.populateCountries();
  }

  async getCountrySchemas() {
    const response = await fetch('https://cdn.shopify.com/s/files/1/0180/7784/3556/files/country-schemas.json?v=1734736930');
    return response.json();
  }

  async populateCountries() {
    this.countryData = await this.getCountrySchemas();
    const tempCountries: { code: string; name: string }[] = [];

    // Add preferred countries first.
    for (const abbrev of this.countryDisplayOrder) {
      const country = this.countryData[abbrev];
      if (country) {
        tempCountries.push({ code: country.code, name: country.name });
      }
    }
    // Add a separator.
    tempCountries.push({ code: '', name: '---' });
    // Add remaining countries.
    for (const abbrev in this.countryData) {
      if (!this.countryDisplayOrder.includes(abbrev)) {
        const country = this.countryData[abbrev];
        tempCountries.push({ code: country.code, name: country.name });
      }
    }
    this.countries = tempCountries;
  }

  displayProvinces(event: any) {
    const countryCode = event.target.value;
    const countrySchema = this.countryData[countryCode];
    this.provinces = [];
    if (countrySchema && countrySchema.fields) {
      let provinceOrState;
      countrySchema.fields.forEach((field: any) => {
        if (['province', 'state', 'state_and_territory', 'region'].includes(field.key)) {
          provinceOrState = field.key;
          field.values.forEach((option: any) => {
            this.provinces.push({ key: option.key, label: option.label });
          });
        }
      });
      if (!provinceOrState) {
        this.provinces = [{ key: 'NA', label: 'Not Applicable' }];
      }
    }
  }

  handleize(str: string): string {
    try {
      str = str.trim();
    } catch (e) {
      console.error(e);
    }
    return str.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  enableOrDisableSubmit(event: any) {
    const form = event.target.closest('form');
    const submitButton = form.querySelector('button[type="submit"]');
    const inputs = form.querySelectorAll('input, textarea, select');
    let canSubmit = form.checkValidity();
    inputs.forEach((input: any) => {
      if (!input.checkValidity()) {
        canSubmit = false;
      }
    });
    if (canSubmit && !this.disabled) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', 'disabled');
    }
  }

  async submitForm(event: Event) {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    if (!form.checkValidity()) {
      form.reportValidity();
      return false;
    }
    const data = new FormData(form);
    await this.generateEmail(data);
    const success = form.parentElement?.querySelector('.success') as HTMLElement;
    if (success) {
      success.style.display = 'block';
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    form.reset();
    return true;
  }

  async generateEmail(data: FormData) {
    const now = new Date();
    const date = now.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateTime = `${date} ${time} ${timeZone}`;
    const formName = data.get('form-name');
    // const to = 'Matt <me@smattmyers.com>';//,BP Gov <bpusgov@bornprimitive.com>';//,BP Gov <bpusgov@bornprimitive.com>
    const to = 'Matt <me@smattmyers.com>, BP Gov <bpusgov@bornprimitive.com>, Tactical <tactical@bornprimitive.com>';//,BP Gov <bpusgov@bornprimitive.com>';//,BP Gov <bpusgov@bornprimitive.com>
    const from = 'BPUS Gov Request <autobot@bornprimitive.com>';
    const subject = 'TAA BERRY Request: ' + data.get('first-name') + ' ' + data.get('last-name');
    const key_date = new Date().toISOString().split('T')[0];
    const key = 'taa-berry/' + this.handleize(String(data.get('first-name') + ' ' + data.get('last-name'))) + '_' + key_date;
    const cache = true;
    let details = '';
    let detailsTxt = '';
    data.forEach((value, key) => {
      details += `<p><strong>${key.replace('-', ' ').toUpperCase()}</strong>: ${value}</p>`;
      detailsTxt += `${key}: ${value}\n`;
    });
    const html = `<h1>${formName}</h1>submitted: ${dateTime}<br>${details}`;
    const text = `${formName}\n${detailsTxt}`;
    // await fetch('https://models.bornprimitive.com/api/send-email', {
    await fetch('/api/contact', {
      method: 'POST',
      body: JSON.stringify({ to, from, subject, text, html, cache, key }),
      headers: { 'Content-Type': 'application/json' }
    });
    this.showSuccessMessage();
  }

  showSuccessMessage() {
    const success = document.querySelector('.success') as HTMLElement;
    if (success) {
      success.style.display = 'block';
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}